"use strict";
/* eslint-disable import/extensions */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var api_1 = require("@src/api");
var BotActions_1 = require("@src/actions/BotActions");
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var accordion_1 = __importDefault(require("relements/build/esm/ui/accordion"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
// Store
var store_1 = __importDefault(require("@src/store"));
// Components
// eslint-disable-next-line import/extensions
var StyledComponets_1 = require("./StyledComponets");
// eslint-disable-next-line import/extensions
var Label_1 = __importDefault(require("./Label"));
var VoiceAgentToolItem_1 = __importDefault(require("./VoiceAgentToolItem"));
var VoiceAgentSidebar_1 = __importDefault(require("./VoiceAgentSidebar"));
var VoiceAgentAddAgentModal_1 = __importDefault(require("./VoiceAgentAddAgentModal"));
var VoiceAgentDynamicSettings_1 = __importDefault(require("./VoiceAgentDynamicSettings"));
var VoiceAgentLayoutUtils_1 = require("./VoiceAgentLayoutUtils");
var api_2 = require("../store/api");
var selectors_1 = require("../store/selectors");
var normalizeDynamicSettingsTemplate = function (template) {
    if (Array.isArray(template))
        return template;
    if (Array.isArray(template === null || template === void 0 ? void 0 : template.agent_settings_template)) {
        return template.agent_settings_template;
    }
    if (Array.isArray(template === null || template === void 0 ? void 0 : template.dynamic_settings)) {
        return template.dynamic_settings;
    }
    if (Array.isArray(template === null || template === void 0 ? void 0 : template.settings)) {
        return template.settings;
    }
    return [];
};
var DEFAULT_AGENT_SETTINGS_TEMPLATE = [
    {
        key: 'enable_smart_stt_endpointing',
        title: 'Enable User Pause Duration',
        type: 'toggle',
        placeholder: null,
        info_text: 'Enabling this uses the User Pause Duration Timeout For STT.',
        "default": false,
        visible_when: null,
    },
    {
        key: 'min_silence_duration_vad',
        title: 'User Pause Duration',
        type: 'slider',
        placeholder: null,
        info_text: "Sets how long a user's pause is treated as the end of their response.\nIncrease this if your bot expects users to provide longer or structured inputs (phone numbers, emails, gift cards).\nDecrease it if your bot expects short, single-sentence replies.\nPlease note: Higher values add directly to the agent's response time.",
        min: 1,
        max: 2,
        min_label: '1.0',
        max_label: '2.0',
        "default": 1,
        visible_when: {
            field_key: 'enable_smart_stt_endpointing',
            "in": [true],
        },
    },
];
var VoiceAgentLayout = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var onAddAgentClick = _a.onAddAgentClick, onDeleteClick = _a.onDeleteClick, onParentSave = _a.onSave, isEdited = _a.isEdited, onDirtyStateChange = _a.onDirtyStateChange;
    var languages = CommonStore_1["default"].getMetaTags().allLanguages;
    var activeDomainId = (_c = (_b = CommonStore_1["default"].getMetaTags()) === null || _b === void 0 ? void 0 : _b.domain) === null || _c === void 0 ? void 0 : _c.id;
    var botSettings = react_redux_1.useSelector(selectors_1.getDomainData);
    var botSettingsDomainId = (_d = botSettings === null || botSettings === void 0 ? void 0 : botSettings.id) !== null && _d !== void 0 ? _d : botSettings === null || botSettings === void 0 ? void 0 : botSettings.domain_id;
    var isDomainDataSynced = String(botSettingsDomainId !== null && botSettingsDomainId !== void 0 ? botSettingsDomainId : '') === String(activeDomainId !== null && activeDomainId !== void 0 ? activeDomainId : '');
    var pipecatVoiceId = isDomainDataSynced
        ? Number(botSettings === null || botSettings === void 0 ? void 0 : botSettings['pipecat_voice_id'])
        : Number.NaN;
    var languagesList = languages.filter(function (lang) { var _a; return (_a = botSettings === null || botSettings === void 0 ? void 0 : botSettings['supported_languages']) === null || _a === void 0 ? void 0 : _a.includes(lang.code); });
    var _r = react_1["default"].useState([]), agents = _r[0], setAgents = _r[1];
    var _s = react_1["default"].useState([]), agentSettingsTemplate = _s[0], setAgentSettingsTemplate = _s[1];
    var _t = react_1["default"].useState(null), selectedAgentId = _t[0], setSelectedAgentId = _t[1];
    var _u = react_1["default"].useState(languagesList[0]), selectedLanguage = _u[0], setSelectedLanguage = _u[1];
    var initializedLanguageKeyRef = react_1["default"].useRef('');
    var _v = react_1["default"].useState(null), currentAgentDraft = _v[0], setCurrentAgentDraft = _v[1];
    var _w = react_1["default"].useState(false), isLocalEdited = _w[0], setIsLocalEdited = _w[1];
    var _x = react_1["default"].useState([]), voiceModels = _x[0], setVoiceModels = _x[1];
    var _y = react_1["default"].useState(true), isLoading = _y[0], setIsLoading = _y[1];
    var _z = react_1["default"].useState(true), isModelsLoading = _z[0], setIsModelsLoading = _z[1];
    var _0 = react_1["default"].useState(false), isSaving = _0[0], setIsSaving = _0[1];
    var _1 = react_1["default"].useState(false), isDeleteLoading = _1[0], setIsDeleteLoading = _1[1];
    var _2 = react_1["default"].useState(false), isAddAgentModalActive = _2[0], setIsAddAgentModalActive = _2[1];
    var _3 = react_1["default"].useState(false), dynamicSettingsAccordionActive = _3[0], setDynamicSettingsAccordionActive = _3[1];
    var _4 = react_1["default"].useState(''), newAgentName = _4[0], setNewAgentName = _4[1];
    var _5 = react_1["default"].useState(''), newAgentNameError = _5[0], setNewAgentNameError = _5[1];
    var lastAccordionResetAgentIdRef = react_1["default"].useRef(null);
    var selectedAgent = react_1["default"].useMemo(function () {
        if (!agents.length)
            return null;
        return (agents.find(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) === selectedAgentId; }) || agents[0]);
    }, [agents, selectedAgentId]);
    var selectedLanguageCode = (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code) || (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.id);
    var getDefaultLanguage = function () {
        var languageSpecificInstructions = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions) || {};
        var languageWithValue = languagesList.find(function (lang) {
            var languageCode = (lang === null || lang === void 0 ? void 0 : lang.code) || (lang === null || lang === void 0 ? void 0 : lang.id);
            return (languageCode &&
                ((languageSpecificInstructions === null || languageSpecificInstructions === void 0 ? void 0 : languageSpecificInstructions[languageCode]) || '').toString().trim()
                    .length > 0);
        });
        return languageWithValue || languagesList[0] || null;
    };
    var configuredLanguageCount = Object.values((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions) || {}).filter(function (value) { return (value || '').toString().trim().length > 0; }).length;
    var isAgentDefault = function (agent) { var _a, _b; return Boolean((_b = (_a = agent === null || agent === void 0 ? void 0 : agent['is_default']) !== null && _a !== void 0 ? _a : agent === null || agent === void 0 ? void 0 : agent.isDefault) !== null && _b !== void 0 ? _b : false); };
    var defaultAgentOtherThanCurrent = agents.find(function (agent) { return isAgentDefault(agent) && VoiceAgentLayoutUtils_1.getAgentId(agent) !== selectedAgentId; });
    var noDefaultAgent = !(agents === null || agents === void 0 ? void 0 : agents.some(function (agent) { return isAgentDefault(agent); }));
    var orchestratorAgentOtherThanCurrent = agents.find(function (agent) {
        return ((agent === null || agent === void 0 ? void 0 : agent.role) === 'orchestrator' || (agent === null || agent === void 0 ? void 0 : agent['role']) === 'orchestrator') &&
            VoiceAgentLayoutUtils_1.getAgentId(agent) !== selectedAgentId;
    });
    var isFaq = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'faq';
    var selectedAgentSettingsTemplate = normalizeDynamicSettingsTemplate((_f = (_e = selectedAgent === null || selectedAgent === void 0 ? void 0 : selectedAgent.agent_settings_template) !== null && _e !== void 0 ? _e : selectedAgent === null || selectedAgent === void 0 ? void 0 : selectedAgent.agentSettingsTemplate) !== null && _f !== void 0 ? _f : agentSettingsTemplate);
    var providerOptions = (function () {
        var providers = new Set();
        voiceModels.forEach(function (model) {
            var _a;
            var provider = (_a = model === null || model === void 0 ? void 0 : model['meta_data']) === null || _a === void 0 ? void 0 : _a.provider;
            if (provider)
                providers.add(provider);
        });
        return Array.from(providers).map(function (provider) { return ({
            id: provider,
            name: provider,
        }); });
    })();
    var modelOptions = (function () {
        return voiceModels
            .filter(function (model) {
            var _a;
            if (!(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.modelProvider))
                return true;
            var provider = (_a = model === null || model === void 0 ? void 0 : model['meta_data']) === null || _a === void 0 ? void 0 : _a.provider;
            return provider === currentAgentDraft.modelProvider;
        })
            .map(function (model) {
            var _a, _b;
            return ({
                // id: model?.id ?? model?.name,
                id: (_a = model === null || model === void 0 ? void 0 : model.name) !== null && _a !== void 0 ? _a : model === null || model === void 0 ? void 0 : model.id,
                name: (_b = model === null || model === void 0 ? void 0 : model.name) !== null && _b !== void 0 ? _b : model === null || model === void 0 ? void 0 : model.id,
            });
        })
            .filter(function (model) { return model.id; });
    })();
    var agentOptions = react_1["default"].useMemo(function () {
        return agents.map(function (agent, index) { return ({
            id: VoiceAgentLayoutUtils_1.getAgentId(agent),
            name: VoiceAgentLayoutUtils_1.getAgentName(agent, index),
        }); });
    }, [agents]);
    var fetchVoiceModels = react_1["default"].useCallback(function () {
        setIsModelsLoading(true);
        api_2.getVoiceModels()
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (!success)
                return;
            var body = VoiceAgentLayoutUtils_1.getResponseBody(response);
            setVoiceModels(VoiceAgentLayoutUtils_1.normalizeList(body));
        })["catch"](function (error) {
            api_1.captureException(error);
        })["finally"](function () {
            setIsModelsLoading(false);
        });
    }, []);
    var fetchMultiAgents = react_1["default"].useCallback(function (preferredAgentId) {
        if (preferredAgentId === void 0) { preferredAgentId = null; }
        if (!Number.isFinite(pipecatVoiceId))
            return;
        setIsLoading(true);
        api_2.getMultiAgent(pipecatVoiceId)
            .then(function (_a) {
            var _b, _c, _d, _e, _f, _g;
            var success = _a.success, response = _a.response;
            if (!success) {
                BotActions_1.createAlert((response === null || response === void 0 ? void 0 : response.error) || 'Failed to fetch voice agents.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                setAgents([]);
                setCurrentAgentDraft(null);
                setSelectedAgentId(null);
                return;
            }
            var body = VoiceAgentLayoutUtils_1.getResponseBody(response);
            var fetchedAgents = VoiceAgentLayoutUtils_1.normalizeList((_c = (_b = body === null || body === void 0 ? void 0 : body.agents) !== null && _b !== void 0 ? _b : body === null || body === void 0 ? void 0 : body.data) !== null && _c !== void 0 ? _c : []);
            var fetchedTemplate = normalizeDynamicSettingsTemplate((_f = (_e = (_d = body === null || body === void 0 ? void 0 : body.agent_settings_template) !== null && _d !== void 0 ? _d : body === null || body === void 0 ? void 0 : body.agentSettingsTemplate) !== null && _e !== void 0 ? _e : body === null || body === void 0 ? void 0 : body.dynamic_settings) !== null && _f !== void 0 ? _f : body === null || body === void 0 ? void 0 : body.settings);
            setAgents(fetchedAgents !== null && fetchedAgents !== void 0 ? fetchedAgents : []);
            setAgentSettingsTemplate(fetchedTemplate !== null && fetchedTemplate !== void 0 ? fetchedTemplate : []);
            if (!fetchedAgents.length) {
                setSelectedAgentId(null);
                setCurrentAgentDraft(null);
                return;
            }
            var idToSelect = (_g = preferredAgentId !== null && preferredAgentId !== void 0 ? preferredAgentId : VoiceAgentLayoutUtils_1.getAgentId(fetchedAgents[0])) !== null && _g !== void 0 ? _g : null;
            setSelectedAgentId(idToSelect);
        })["catch"](function (error) {
            BotActions_1.createAlert('Error occurred while fetching voice agents.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            api_1.captureException(error);
        })["finally"](function () {
            setIsLoading(false);
        });
    }, [pipecatVoiceId]);
    react_1["default"].useEffect(function () {
        if (!selectedAgent) {
            setCurrentAgentDraft(null);
            return;
        }
        var selectedAgentDraft = VoiceAgentLayoutUtils_1.toAgentDraft(selectedAgent);
        setCurrentAgentDraft(selectedAgentDraft);
        setIsLocalEdited(Boolean(selectedAgentDraft === null || selectedAgentDraft === void 0 ? void 0 : selectedAgentDraft.isNew));
        if (lastAccordionResetAgentIdRef.current !== selectedAgentId) {
            setDynamicSettingsAccordionActive(false);
            lastAccordionResetAgentIdRef.current = selectedAgentId;
        }
    }, [selectedAgent, selectedAgentId]);
    react_1["default"].useEffect(function () {
        setAgents([]);
        setAgentSettingsTemplate([]);
        setSelectedAgentId(null);
        setCurrentAgentDraft(null);
        setIsLocalEdited(false);
        setIsLoading(true);
        setIsModelsLoading(true);
        setIsAddAgentModalActive(false);
        setNewAgentName('');
        setNewAgentNameError('');
    }, [activeDomainId]);
    react_1["default"].useEffect(function () {
        if (!Number.isFinite(pipecatVoiceId)) {
            setAgents([]);
            setAgentSettingsTemplate([]);
            setSelectedAgentId(null);
            setCurrentAgentDraft(null);
            setIsLocalEdited(false);
            setIsLoading(false);
            setIsModelsLoading(false);
            return;
        }
        fetchMultiAgents();
        fetchVoiceModels();
    }, [pipecatVoiceId, fetchMultiAgents, fetchVoiceModels]);
    react_1["default"].useEffect(function () {
        var _a, _b;
        if (!languagesList.length) {
            initializedLanguageKeyRef.current = '';
            setSelectedLanguage(null);
            return;
        }
        var draftKey = String((_b = (_a = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id) !== null && _a !== void 0 ? _a : selectedAgentId) !== null && _b !== void 0 ? _b : 'none');
        var selectedLanguageCode = (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code) || (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.id);
        var selectedExists = selectedLanguageCode
            ? languagesList.some(function (lang) {
                return lang.code === selectedLanguageCode ||
                    lang.id === selectedLanguageCode;
            })
            : false;
        var shouldInitialize = initializedLanguageKeyRef.current !== draftKey || !selectedExists;
        if (shouldInitialize) {
            setSelectedLanguage(getDefaultLanguage());
            initializedLanguageKeyRef.current = draftKey;
        }
    }, [
        currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id,
        currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions,
        languagesList,
        selectedAgentId,
        selectedLanguage,
    ]);
    react_1["default"].useEffect(function () {
        if (onDirtyStateChange) {
            onDirtyStateChange(Boolean(isLocalEdited || isEdited));
        }
        return function () {
            if (onDirtyStateChange)
                onDirtyStateChange(false);
        };
    }, [isLocalEdited, isEdited, onDirtyStateChange]);
    var updateAgentDraft = function (field, value) {
        setCurrentAgentDraft(function (prev) {
            var _a;
            var updatedDraft = __assign(__assign({}, (prev || {})), (_a = {}, _a[field] = value, _a));
            if (field === 'role' && value === 'faq') {
                var removedToolIds = (updatedDraft.tools || [])
                    .map(function (tool) { return tool === null || tool === void 0 ? void 0 : tool.id; })
                    .filter(function (toolId) { return toolId !== null && toolId !== undefined; });
                updatedDraft.deletedToolIds = Array.from(new Set(__spreadArrays((updatedDraft.deletedToolIds || []), removedToolIds)));
                updatedDraft.isDefault = false;
                updatedDraft.tools = [];
            }
            return updatedDraft;
        });
        setIsLocalEdited(true);
    };
    var updateAgentSettingsDraft = function (key, value) {
        setCurrentAgentDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, (prev || {})), { agentSettings: __assign(__assign({}, ((prev === null || prev === void 0 ? void 0 : prev.agentSettings) || {})), (_a = {}, _a[key] = value, _a)) }));
        });
        setIsLocalEdited(true);
    };
    var updateToolDraft = function (index, field, value) {
        setCurrentAgentDraft(function (prev) {
            var _a;
            var _b;
            var updatedTools = __spreadArrays(((_b = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _b !== void 0 ? _b : []));
            updatedTools[index] = __assign(__assign({}, (updatedTools[index] || VoiceAgentLayoutUtils_1.normalizeTool({}))), (_a = {}, _a[field] = value, _a));
            return __assign(__assign({}, (prev || {})), { tools: updatedTools });
        });
        setIsLocalEdited(true);
    };
    var onDeleteTool = function (index) {
        setCurrentAgentDraft(function (prev) {
            var _a;
            var updatedTools = __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []));
            var removedTool = updatedTools[index];
            var removedToolId = removedTool === null || removedTool === void 0 ? void 0 : removedTool.id;
            updatedTools.splice(index, 1);
            return __assign(__assign({}, (prev || {})), { tools: updatedTools, deletedToolIds: removedToolId === null || removedToolId === undefined
                    ? (prev === null || prev === void 0 ? void 0 : prev.deletedToolIds) || []
                    : Array.from(new Set(__spreadArrays(((prev === null || prev === void 0 ? void 0 : prev.deletedToolIds) || []), [removedToolId]))) });
        });
        setIsLocalEdited(true);
    };
    var getAffectedRoutingAgents = function (targetAgentName, deletingAgentId) {
        return agents
            .filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== deletingAgentId; })
            .map(function (agent) {
            var draft = VoiceAgentLayoutUtils_1.toAgentDraft(agent);
            var removedTools = ((draft === null || draft === void 0 ? void 0 : draft.tools) || []).filter(function (tool) {
                return (tool === null || tool === void 0 ? void 0 : tool.mode) === 'handoff' && (tool === null || tool === void 0 ? void 0 : tool.nextAgent) === targetAgentName;
            });
            if (!removedTools.length)
                return null;
            return {
                id: draft === null || draft === void 0 ? void 0 : draft.id,
                isNew: Boolean(draft === null || draft === void 0 ? void 0 : draft.isNew),
                name: VoiceAgentLayoutUtils_1.getAgentName(agent, 0),
                removedTools: removedTools,
                updatedDraft: __assign(__assign({}, draft), { tools: ((draft === null || draft === void 0 ? void 0 : draft.tools) || []).filter(function (tool) {
                        return !((tool === null || tool === void 0 ? void 0 : tool.mode) === 'handoff' &&
                            (tool === null || tool === void 0 ? void 0 : tool.nextAgent) === targetAgentName);
                    }), deletedToolIds: Array.from(new Set(__spreadArrays(((draft === null || draft === void 0 ? void 0 : draft.deletedToolIds) || []), removedTools
                        .map(function (tool) { return tool === null || tool === void 0 ? void 0 : tool.id; })
                        .filter(function (toolId) { return toolId !== null && toolId !== undefined; })))) }),
            };
        })
            .filter(Boolean);
    };
    var onAddTool = function () {
        setCurrentAgentDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, (prev || {})), { tools: __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []), [VoiceAgentLayoutUtils_1.normalizeTool({ id: null })]) }));
        });
        setIsLocalEdited(true);
    };
    var onAddAgent = function () {
        if (isLocalEdited || isEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Continue',
                cancelTitle: 'Keep Editing',
                title: 'Create a new agent?',
                message: 'Your unsaved changes in the current agent will be lost if you continue.',
                okActionType: 'danger',
                onCancel: function () { },
                onOk: function () {
                    setIsAddAgentModalActive(true);
                    setNewAgentName('');
                    setNewAgentNameError('');
                },
            });
            return;
        }
        setIsAddAgentModalActive(true);
        setNewAgentName('');
        setNewAgentNameError('');
    };
    var onConfirmAddAgent = function () {
        var trimmedAgentName = (newAgentName || '').trim();
        if (!trimmedAgentName) {
            setNewAgentNameError('Agent name is required.');
            BotActions_1.createAlert('Please enter an agent name.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var isDuplicateAgentName = agents.some(function (agent) {
            return (VoiceAgentLayoutUtils_1.getAgentName(agent, 0) || '').trim().toLowerCase() ===
                trimmedAgentName.toLowerCase();
        });
        if (isDuplicateAgentName) {
            setNewAgentNameError('An agent with this name already exists.');
            BotActions_1.createAlert('Agent name already exists. Please choose a different name.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        setNewAgentNameError('');
        if (!Number.isFinite(pipecatVoiceId) && onAddAgentClick) {
            onAddAgentClick();
        }
        var tempId = "new-" + Date.now();
        var localNewAgent = {
            id: tempId,
            name: trimmedAgentName,
            title: trimmedAgentName,
            llm_provider: '',
            llm_model: '',
            instructions: '',
            language_specific_instructions: {},
            role: 'specialist',
            is_default: agents.length === 0,
            date_time_context_enabled: false,
            deleted_tool_ids: [],
            agentSettings: {},
            tools: [],
            isNew: true,
        };
        setAgents(function (prev) { return __spreadArrays(prev, [localNewAgent]); });
        setSelectedAgentId(tempId);
        setCurrentAgentDraft(VoiceAgentLayoutUtils_1.toAgentDraft(localNewAgent));
        setIsLocalEdited(true);
        setIsAddAgentModalActive(false);
        setNewAgentName('');
        setNewAgentNameError('');
    };
    var onSave = function () {
        var trimmedDraft = VoiceAgentLayoutUtils_1.trimAgentDraft(currentAgentDraft);
        setCurrentAgentDraft(trimmedDraft);
        if (!Number.isFinite(pipecatVoiceId)) {
            if (onParentSave)
                onParentSave();
            return;
        }
        if (!(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.id)) {
            BotActions_1.createAlert('Please select an agent first.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if (!(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.modelProvider) || !(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.model)) {
            BotActions_1.createAlert('Please select both model provider and model before saving.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var draftTools = Array.isArray(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.tools)
            ? trimmedDraft.tools
            : [];
        var missingBehaviorIndex = draftTools.findIndex(function (tool) { return !((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim(); });
        if (missingBehaviorIndex !== -1) {
            BotActions_1.createAlert("Tool " + (missingBehaviorIndex + 1) + ": Tool behavior is required.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var missingNameIndex = draftTools.findIndex(function (tool) { return !((tool === null || tool === void 0 ? void 0 : tool.name) || '').toString().trim(); });
        if (missingNameIndex !== -1) {
            BotActions_1.createAlert("Tool " + (missingNameIndex + 1) + ": Tool name is required.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var invalidToolNameIndex = draftTools.findIndex(function (tool) {
            return !VoiceAgentLayoutUtils_1.TOOL_NAME_REGEX.test(((tool === null || tool === void 0 ? void 0 : tool.name) || '').toString().trim() || '');
        });
        if (invalidToolNameIndex !== -1) {
            BotActions_1.createAlert("Tool " + (invalidToolNameIndex + 1) + ": Tool name can only contain letters, numbers and underscore.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var missingDescriptionIndex = draftTools.findIndex(function (tool) { return !((tool === null || tool === void 0 ? void 0 : tool.description) || '').toString().trim(); });
        if (missingDescriptionIndex !== -1) {
            BotActions_1.createAlert("Tool " + (missingDescriptionIndex + 1) + ": Tool description is required.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var missingNextAgentIndex = draftTools.findIndex(function (tool) {
            return ((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() === 'handoff' &&
                !((tool === null || tool === void 0 ? void 0 : tool.nextAgent) || '').toString().trim();
        });
        if (missingNextAgentIndex !== -1) {
            BotActions_1.createAlert("Tool " + (missingNextAgentIndex + 1) + ": Next agent is required for handoff.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var invalidRagTool = draftTools.reduce(function (acc, tool, toolIndex) {
            if (acc)
                return acc;
            if (((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() !== 'rag')
                return null;
            if (!((tool === null || tool === void 0 ? void 0 : tool.appId) || '').toString().trim()) {
                return {
                    toolIndex: toolIndex,
                    message: 'RAG App ID is required.',
                };
            }
            if (!VoiceAgentLayoutUtils_1.RAG_APP_ID_REGEX.test(((tool === null || tool === void 0 ? void 0 : tool.appId) || '').toString().trim())) {
                return {
                    toolIndex: toolIndex,
                    message: 'RAG App ID can only contain letters, numbers, underscore and hyphen.',
                };
            }
            if (!((tool === null || tool === void 0 ? void 0 : tool.prompt) || '').toString().trim()) {
                return {
                    toolIndex: toolIndex,
                    message: 'RAG Prompt is required.',
                };
            }
            return null;
        }, null);
        if (invalidRagTool) {
            BotActions_1.createAlert("Tool " + (invalidRagTool.toolIndex + 1) + ": " + invalidRagTool.message, null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var invalidToolCallParameter = draftTools.reduce(function (acc, tool, toolIndex) {
            if (acc)
                return acc;
            if (((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() !== 'tool_call')
                return null;
            var normalizedParameters = VoiceAgentLayoutUtils_1.normalizeToolParameters(tool === null || tool === void 0 ? void 0 : tool.parameters);
            var parameterEntries = Object.entries((normalizedParameters === null || normalizedParameters === void 0 ? void 0 : normalizedParameters.properties) || {});
            for (var parameterIndex = 0; parameterIndex < parameterEntries.length; parameterIndex += 1) {
                var _a = parameterEntries[parameterIndex], parameterName = _a[0], parameterSchema = _a[1];
                var trimmedParameterName = (parameterName || '').toString().trim();
                var trimmedParameterType = ((parameterSchema === null || parameterSchema === void 0 ? void 0 : parameterSchema.type) || '')
                    .toString()
                    .trim();
                var trimmedParameterDescription = ((parameterSchema === null || parameterSchema === void 0 ? void 0 : parameterSchema.description) || '')
                    .toString()
                    .trim();
                if (!trimmedParameterName) {
                    return {
                        toolIndex: toolIndex,
                        parameterIndex: parameterIndex,
                        field: 'name',
                    };
                }
                if (!VoiceAgentLayoutUtils_1.PARAMETER_NAME_REGEX.test(trimmedParameterName)) {
                    return {
                        toolIndex: toolIndex,
                        parameterIndex: parameterIndex,
                        field: 'name_format',
                    };
                }
                if (!trimmedParameterType) {
                    return {
                        toolIndex: toolIndex,
                        parameterIndex: parameterIndex,
                        field: 'type',
                    };
                }
                if (!trimmedParameterDescription) {
                    return {
                        toolIndex: toolIndex,
                        parameterIndex: parameterIndex,
                        field: 'description',
                    };
                }
            }
            return null;
        }, null);
        if (invalidToolCallParameter) {
            var parameterFieldLabel = invalidToolCallParameter.field === 'name_format'
                ? 'name can only contain letters, numbers and underscore'
                : invalidToolCallParameter.field + " is required";
            BotActions_1.createAlert("Tool " + (invalidToolCallParameter.toolIndex + 1) + ", Parameter " + (invalidToolCallParameter.parameterIndex + 1) + ": " + parameterFieldLabel + ".", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var normalizedToolNames = draftTools.map(function (tool) {
            return ((tool === null || tool === void 0 ? void 0 : tool.name) || '').toString().trim().toLowerCase();
        });
        var duplicateToolName = normalizedToolNames.find(function (name, index) { return name && normalizedToolNames.indexOf(name) !== index; });
        if (duplicateToolName) {
            BotActions_1.createAlert("Tool name \"" + duplicateToolName + "\" already exists. Please use a unique tool name.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.role) === 'faq' && (trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.isDefault)) {
            BotActions_1.createAlert('FAQ agent cannot be marked as Default. Please select another agent as Default.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.isDefault) && defaultAgentOtherThanCurrent) {
            BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(defaultAgentOtherThanCurrent, 0) + " is already marked as Default. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.role) === 'orchestrator' &&
            orchestratorAgentOtherThanCurrent) {
            BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(orchestratorAgentOtherThanCurrent, 0) + " is already set as Orchestrator. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        setIsSaving(true);
        var requestPromise = (trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.isNew) ? api_2.createMultiAgentBot(pipecatVoiceId, VoiceAgentLayoutUtils_1.buildAgentPayload(__assign(__assign({}, trimmedDraft), { id: undefined })))
            : api_2.updateMultiAgent(pipecatVoiceId, trimmedDraft.id, VoiceAgentLayoutUtils_1.buildAgentPayload(trimmedDraft));
        requestPromise
            .then(function (_a) {
            var _b, _c, _d;
            var success = _a.success, response = _a.response;
            if (!success || (response === null || response === void 0 ? void 0 : response.success) === false) {
                BotActions_1.createAlert((response === null || response === void 0 ? void 0 : response.error) || 'Error occurred while saving agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                return;
            }
            BotActions_1.createAlert('Successfully saved the agent data.', null, MogamboConstants_1.AlertTypes.POSITIVE);
            setIsLocalEdited(false);
            var createdAgentId = (_d = (_b = VoiceAgentLayoutUtils_1.getAgentId(VoiceAgentLayoutUtils_1.getResponseBody(response))) !== null && _b !== void 0 ? _b : VoiceAgentLayoutUtils_1.getAgentId((_c = VoiceAgentLayoutUtils_1.getResponseBody(response)) === null || _c === void 0 ? void 0 : _c.agent)) !== null && _d !== void 0 ? _d : trimmedDraft.id;
            fetchMultiAgents(createdAgentId);
        })["catch"](function (error) {
            BotActions_1.createAlert('Error occurred while saving agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            api_1.captureException(error);
        })["finally"](function () {
            setIsSaving(false);
        });
    };
    var onDelete = function () {
        var deletingAgentName = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || '';
        var deletingAgentId = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id;
        var affectedAgents = getAffectedRoutingAgents(deletingAgentName, deletingAgentId);
        var totalAffectedTools = affectedAgents.reduce(function (acc, agent) { var _a; return acc + (((_a = agent === null || agent === void 0 ? void 0 : agent.removedTools) === null || _a === void 0 ? void 0 : _a.length) || 0); }, 0);
        var affectedAgentsText = affectedAgents
            .map(function (agent) { return (agent === null || agent === void 0 ? void 0 : agent.name) + " (" + (agent === null || agent === void 0 ? void 0 : agent.removedTools.length) + ")"; })
            .join(', ');
        var deleteMessage = affectedAgents.length ? (react_1["default"].createElement(box_1["default"], null,
            react_1["default"].createElement(text_1["default"], { variant: "body.md", style: { whiteSpace: 'pre-line', fontSize: '15px' } }, "This agent is used as routing target in " + totalAffectedTools + " tool(s) in: " + affectedAgentsText + ".\nThose routing tools will also be deleted."))) : ('This action cannot be undone.');
        BotActions_1.showConfirmationDialog({
            okTitle: 'Delete',
            cancelTitle: 'Cancel',
            title: "Are you sure you want to delete '" + ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || 'this agent') + "'?",
            message: deleteMessage,
            okActionType: 'danger',
            onCancel: function () { },
            onOk: function () {
                var _a;
                if (affectedAgents.length) {
                    setAgents(function (prevAgents) {
                        return prevAgents.map(function (agent) {
                            var agentId = VoiceAgentLayoutUtils_1.getAgentId(agent);
                            var affected = affectedAgents.find(function (a) { return (a === null || a === void 0 ? void 0 : a.id) === agentId; });
                            if (!affected || !affected.isNew)
                                return agent;
                            return __assign(__assign({}, agent), { tools: affected.updatedDraft.tools, deleted_tool_ids: affected.updatedDraft.deletedToolIds });
                        });
                    });
                }
                if (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) {
                    var updatedAgents = agents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
                    setAgents(updatedAgents);
                    var fallbackId = (_a = VoiceAgentLayoutUtils_1.getAgentId(updatedAgents === null || updatedAgents === void 0 ? void 0 : updatedAgents[0])) !== null && _a !== void 0 ? _a : null;
                    setSelectedAgentId(fallbackId);
                    if (!updatedAgents.length) {
                        setCurrentAgentDraft(null);
                    }
                    setIsLocalEdited(false);
                    return;
                }
                if (!Number.isFinite(pipecatVoiceId) || !(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id)) {
                    if (onDeleteClick)
                        onDeleteClick(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id);
                    return;
                }
                setIsDeleteLoading(true);
                var updateAffectedAgentsPromise = Promise.all(affectedAgents
                    .filter(function (agent) { return !(agent === null || agent === void 0 ? void 0 : agent.isNew) && (agent === null || agent === void 0 ? void 0 : agent.id); })
                    .map(function (agent) {
                    return api_2.updateMultiAgent(pipecatVoiceId, agent === null || agent === void 0 ? void 0 : agent.id, VoiceAgentLayoutUtils_1.buildAgentPayload(agent === null || agent === void 0 ? void 0 : agent.updatedDraft));
                }));
                updateAffectedAgentsPromise
                    .then(function (responses) {
                    var _a;
                    var failedUpdate = responses.find(function (_a) {
                        var success = _a.success, response = _a.response;
                        return !success || (response === null || response === void 0 ? void 0 : response.success) === false;
                    });
                    if (failedUpdate) {
                        throw new Error(((_a = failedUpdate === null || failedUpdate === void 0 ? void 0 : failedUpdate.response) === null || _a === void 0 ? void 0 : _a.error) ||
                            'Error occurred while updating routing tools.');
                    }
                    return api_2.deleteMultiAgent(pipecatVoiceId, currentAgentDraft.id, {});
                })
                    .then(function (_a) {
                    var success = _a.success, response = _a.response;
                    if (!success || (response === null || response === void 0 ? void 0 : response.success) === false) {
                        BotActions_1.createAlert((response === null || response === void 0 ? void 0 : response.error) || 'Error occurred while deleting agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return;
                    }
                    BotActions_1.createAlert('Agent deleted successfully.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    fetchMultiAgents();
                })["catch"](function (error) {
                    BotActions_1.createAlert((error === null || error === void 0 ? void 0 : error.message) || 'Error occurred while deleting agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    api_1.captureException(error);
                })["finally"](function () {
                    setIsDeleteLoading(false);
                });
            },
        });
    };
    var onAgentSelect = function (agentId) {
        if (agentId === selectedAgentId)
            return;
        if (isLocalEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Switch',
                cancelTitle: 'Keep Editing',
                title: 'Switch agent?',
                message: 'Your unsaved changes will be lost once you switch to another agent.',
                okActionType: 'danger',
                onCancel: function () { },
                onOk: function () {
                    if ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id)) {
                        setAgents(function (prevAgents) {
                            return prevAgents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
                        });
                    }
                    setSelectedAgentId(agentId);
                    setIsLocalEdited(false);
                },
            });
            return;
        }
        setSelectedAgentId(agentId);
    };
    var selectedProvider = providerOptions.find(function (provider) { return provider.id === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.modelProvider); }) || {};
    var selectedModel = modelOptions.find(function (model) { return model.id === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.model); }) || {};
    var selectedRole = VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS.find(function (role) { return role.id === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role); }) ||
        VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS[0];
    var currentAgentIndex = agents.findIndex(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(box_1["default"], { flexDirection: "row", padding: "0", style: { gap: '24px' } },
            react_1["default"].createElement(VoiceAgentSidebar_1["default"], { isLoading: isLoading, agentOptions: agentOptions, selectedAgentId: selectedAgentId, onAgentSelect: onAgentSelect, onAddAgent: onAddAgent }),
            selectedAgentId || isLoading || isModelsLoading ? (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { flex: 1, minWidth: 0 } },
                react_1["default"].createElement(box_1["default"], { style: { alignSelf: 'flex-end', gap: '4px' } },
                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: isSaving || isDeleteLoading || !currentAgentDraft
                            ? 'disabled'
                            : 'warning', onClick: onDelete, disabled: isSaving || isDeleteLoading || !currentAgentDraft }, "Delete"),
                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, type: "primary", onClick: onSave, disabled: !currentAgentDraft ||
                            isSaving ||
                            isDeleteLoading ||
                            store_1["default"].isProductionEnv() ||
                            (!isLocalEdited && !isEdited) }, isSaving ? 'Saving...' : 'Save')),
                react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { gap: '8px', marginTop: '8px' } },
                    (isLoading || isModelsLoading) && (react_1["default"].createElement(box_1["default"], { height: "100%", alignItems: "center", justifyContent: "center" },
                        react_1["default"].createElement(loader_1["default"], { themed: true }))),
                    isDeleteLoading && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "Deleting agent...")),
                    !isLoading && !isModelsLoading && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(box_1["default"], { flexDirection: "column", style: { gap: '6px' } },
                            react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "black.haptik" }, currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name)),
                        react_1["default"].createElement(box_1["default"], { style: { gap: '16px' } },
                            react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select a model provider", themed: true, options: providerOptions, value: selectedProvider, optionKey: "name", onChange: function (val) {
                                    var _a;
                                    updateAgentDraft('modelProvider', (_a = val === null || val === void 0 ? void 0 : val.id) !== null && _a !== void 0 ? _a : '');
                                    updateAgentDraft('model', '');
                                }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Model Provider", isBold: true }) }),
                            react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select a model", themed: true, options: modelOptions, value: selectedModel, optionKey: "name", onChange: function (val) { var _a; return updateAgentDraft('model', (_a = val === null || val === void 0 ? void 0 : val.id) !== null && _a !== void 0 ? _a : ''); }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Model", isBold: true }) })),
                        react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Agent Role"),
                            react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select agent role", themed: true, options: VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS, value: selectedRole, optionKey: "name", onChange: function (val) {
                                    if ((val === null || val === void 0 ? void 0 : val.id) === 'orchestrator' &&
                                        orchestratorAgentOtherThanCurrent) {
                                        BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(orchestratorAgentOtherThanCurrent, 0) + " is already set as Orchestrator. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                                        return;
                                    }
                                    updateAgentDraft('role', val === null || val === void 0 ? void 0 : val.id);
                                }, style: { width: '200px' } })),
                        react_1["default"].createElement(box_1["default"], { padding: "0px 8px", alignItems: "center", style: { gap: '8px' } },
                            react_1["default"].createElement(toggle_1["default"], { themed: true, value: Boolean(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isDefault), onChange: function (checked) {
                                    if (checked && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'faq') {
                                        BotActions_1.createAlert('FAQ agent cannot be marked as Default. Please select another agent as Default.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                                        return;
                                    }
                                    if (checked && defaultAgentOtherThanCurrent) {
                                        BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(defaultAgentOtherThanCurrent, 0) + " is already marked as Default. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                                        return;
                                    }
                                    updateAgentDraft('isDefault', checked);
                                }, disabled: store_1["default"].isProductionEnv(), style: { width: 'max-content' } }),
                            noDefaultAgent &&
                                !(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isDefault) &&
                                currentAgentIndex === 0 && (react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "green.haptik" }, "(Considered Default)")),
                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Is this Agent the \"Default\" Agent?")),
                        react_1["default"].createElement(box_1["default"], { padding: "0px 8px", alignItems: "center", style: { gap: '8px' } },
                            react_1["default"].createElement(toggle_1["default"], { themed: true, value: Boolean(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.enableDateTimeContext), onChange: function (checked) {
                                    return updateAgentDraft('enableDateTimeContext', checked);
                                }, disabled: store_1["default"].isProductionEnv(), style: { width: 'max-content' } }),
                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Enable Date/Time context for this Agent")),
                        Array.isArray(selectedAgentSettingsTemplate) &&
                            selectedAgentSettingsTemplate.length > 0 &&
                            !isFaq && (react_1["default"].createElement(accordion_1["default"], null,
                            react_1["default"].createElement(StyledComponets_1.DynamicSettingsAccordionItem, { active: dynamicSettingsAccordionActive, onChange: function () {
                                    return setDynamicSettingsAccordionActive(function (active) { return !active; });
                                }, renderHeader: function (_a) {
                                    var ExpandIcon = _a.ExpandIcon;
                                    return (react_1["default"].createElement(box_1["default"], { color: "black.haptik", padding: "8px 16px", justifyContent: "space-between", marginBottom: dynamicSettingsAccordionActive ? '8px' : '0', alignItems: "center" },
                                        react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Settings"),
                                        react_1["default"].createElement(ExpandIcon, null)));
                                } },
                                react_1["default"].createElement(VoiceAgentDynamicSettings_1["default"], { dynamicSettings: selectedAgentSettingsTemplate, agentSettings: currentAgentDraft, onChange: updateAgentSettingsDraft })))),
                        react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Prompt"),
                            react_1["default"].createElement(StyledComponets_1.StyledTextInputDisabled, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "No common prompt added yet.", value: (_h = (_g = botSettings === null || botSettings === void 0 ? void 0 : botSettings.bot_settings) === null || _g === void 0 ? void 0 : _g['common_system_prompt']) !== null && _h !== void 0 ? _h : '', disabled: true })),
                        react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Agent Instructions"),
                            react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter Instructions for the agent", value: (_j = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.instructions) !== null && _j !== void 0 ? _j : '', onChange: function (value) {
                                    return updateAgentDraft('instructions', value);
                                } })),
                        react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Guardrails"),
                            react_1["default"].createElement(StyledComponets_1.StyledTextInputDisabled, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "No common guardrails added yet.", value: (_l = (_k = botSettings === null || botSettings === void 0 ? void 0 : botSettings.bot_settings) === null || _k === void 0 ? void 0 : _k['common_guardrails']) !== null && _l !== void 0 ? _l : '', disabled: true })),
                        react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Language Specific Instructions"),
                            react_1["default"].createElement(box_1["default"], { padding: "2px 0px 8px", style: { gap: '12px' }, alignItems: "flex-start" },
                                react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { minWidth: '200px' } },
                                    react_1["default"].createElement(dropdown_1["default"], { themed: true, placeholder: "Select language", options: languagesList, value: selectedLanguage, optionKey: "name", onChange: function (val) { return setSelectedLanguage(val); }, style: { width: '200px' } }),
                                    react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark", style: { marginTop: '8px' } },
                                        configuredLanguageCount,
                                        " languages configured")),
                                react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter Instructions for the agent", value: (_o = (_m = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions) === null || _m === void 0 ? void 0 : _m[selectedLanguageCode]) !== null && _o !== void 0 ? _o : '', onChange: function (value) {
                                        var _a;
                                        return updateAgentDraft('languageSpecificInstructions', __assign(__assign({}, currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions), (_a = {}, _a[selectedLanguageCode] = value, _a)));
                                    }, disabled: !(selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code), style: { marginTop: '6px', minHeight: '200px' } }))),
                        !isFaq && (react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                            react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold", color: "black.haptik" }, "Tools"),
                            ((_p = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.tools) !== null && _p !== void 0 ? _p : []).map(function (tool, index) {
                                return (react_1["default"].createElement(VoiceAgentToolItem_1["default"], { key: (tool === null || tool === void 0 ? void 0 : tool.id) || "tool-" + index, toolData: tool, number: index + 1, nextAgentOptions: agentOptions.filter(function (agent) { return agent.id !== selectedAgentId; }), onToolChange: function (field, value) {
                                        return updateToolDraft(index, field, value);
                                    }, onDeleteTool: function () { return onDeleteTool(index); } }));
                            }),
                            !((_q = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.tools) === null || _q === void 0 ? void 0 : _q.length) && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "No tools added for this agent.")),
                            react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "flex-end" },
                                react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: "secondary", onClick: onAddTool }, "Add tool"))))))))) : (react_1["default"].createElement(box_1["default"], { padding: "16px", height: "calc(100vh - 140px)", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#fff", style: { borderRadius: '8px' } },
                react_1["default"].createElement("img", { src: "https://tools-cdn.s3.ap-south-1.amazonaws.com/platform/assets/no_agents_multi_agent.png", alt: "No agents", style: { width: '40%', marginBottom: '16px' } }),
                react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold" }, "No agents in this project yet"),
                react_1["default"].createElement(text_1["default"], { variant: "body.lg", style: { marginTop: '8px', width: '50%', textAlign: 'center' } }, "Create your first AI agent using \u201CAdd Agent\u201D in the sidebar. You can add multiple agents to handle different tasks.")))),
        react_1["default"].createElement(VoiceAgentAddAgentModal_1["default"], { isActive: isAddAgentModalActive, newAgentName: newAgentName, newAgentNameError: newAgentNameError, setNewAgentName: setNewAgentName, setNewAgentNameError: setNewAgentNameError, onConfirm: onConfirmAddAgent, onClose: function () {
                setIsAddAgentModalActive(false);
                setNewAgentName('');
                setNewAgentNameError('');
            } })));
};
exports["default"] = VoiceAgentLayout;
